import { toSize, toPixel, toLnglat } from "../utils";
export var configurableProps = ['content', 'position', 'size', 'offset', /* 扩展属性 */
'visible'];
export var allProps = configurableProps.concat(['isCustom', 'autoMove', 'closeWhenClickMap', 'showShadow', 'avoid']);
export var converterMap = {
  size: toSize,
  offset: toPixel,
  position: toLnglat
};